import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog, PartnerFullModel } from 'Models'
import { UserShortModel } from 'Pages/auth'
import { BaseItem } from 'Types/item'

export const partnerApi = {
	getPartnerPrivateInfoApi: async (id: number, type: string) => {
		const res = await axiosDS().get(
			`${urls.pp.partner.info.replace(':id', id.toString()).replace(':type', type)}`
		)
		return res.data
	},

	getPartnerProducts: async (id: number) => {
		const res = await axiosDS().get<ResponseCatalog<BaseItem>>(
			`${urls.pp.partner.products.replace(':id', id.toString())}`
		)
		return res.data
	},

	patchPartnerBlocking: async (id: number) => {
		const res = await axiosDS().patch<Record<string, string>>(
			`${urls.pp.partner.partner_blocking.replace(':id', id.toString())}`
		)
		return res.data
	},

	getPartnerInfoById: async (id: number, query?: string) => {
		const res = await axiosDS().get<PartnerFullModel>(
			`${urls.pp.partner.show.replace(':id', id.toString())}${query || ''}`
		)
		return res.data
	},

	SendPartnerXmlToCrm: async (id: number) => {
		const res = await axiosDS().patch(
			`${urls.pp.partner.send_xml_to_crm.replace(':id', id.toString())}`
		)
		return res.data
	},

	getPartnerActiveUsers: async (partner_id: number, page: number) => {
		const params = new RequestParams(page, 30, undefined, {
			is_deleted: false,
			is_active: true,
			partner_id,
		})
		const res = await axiosDS().get<ResponseCatalog<UserShortModel>>(urls.common.catalogs.user, {
			params,
		})
		return res.data
	},

	liquidatePartner: async (partner_id: number) => {
		const res = await axiosDS().patch<PartnerFullModel>(
			urls.pp.partner.liquidate.replace(':id', partner_id.toString())
		)
		return res.data
	},

	revertLiquidation: async (partner_id: number) => {
		const res = await axiosDS().patch<PartnerFullModel>(
			urls.pp.partner.revert_liquidation.replace(':id', partner_id.toString())
		)
		return res.data
	},
}
